import { StringField } from '@components/Fields/StringField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IForm } from '@hooks/useForm';
import { IResetarSenhaRequest } from '@services/UsuarioService';
import React from 'react';

export type UsuarioResetarSenhaFormProps = {
    form: IForm<IResetarSenhaRequest>
}

export function UsuarioResetarSenhaForm ({ form }: UsuarioResetarSenhaFormProps) {
    const { fields } = form;

    return (
        <HorizontalGrid spacing={1}>
            <GridItem xs={6}>
                <StringField 
                    field={fields.novaSenha}
                    label="Nova Senha"
                    helperText="Mínimo 6 caracteres"
                />
            </GridItem>

            <GridItem xs={6}>
                <StringField 
                    field={fields.confirmarNovaSenha}
                    label="Confirmar Nova Senha"
                    helperText="Mínimo 6 caracteres"
                />
            </GridItem>
        </HorizontalGrid>
    )
}